module.exports = __webpack_public_path__ + "img/todo.e7fc07b6.png";